export const config = {
  username: {
    required: true,
    rules: [(value: string) => ({
      'valid': value.length > 1 && value.length <= 255,
      'data-error': ''
    }), (value: string) => ({
      'valid': /[A-Za-z0-9_@.]+/.test(value),
      'data-error': ''
    })]
  },
  password: {
    required: true,
    rules: [(value: string) => ({
      'valid': /[a-zA-Z0-9!@#$%^&*()]+/.test(value),
      'data-error': ''
    })]
  }
};
